import {
  BULK_DELETE_WARNING,
  BULK_LOCK_WARNING,
  BULK_UNLOCK_WARNING,
  ListMenuItem,
  Typography,
  newToast,
} from "@compass/core";
import { Permission, PermissionAction } from "generated/openApi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import { isAuthorized } from "services";
import ApiService from "services/apiService";
import {
  StudentServiceBulkUpdatePageState,
  studentServiceBulkUpdatePageRoute,
} from "../StudentServiceBulkUpdatePage/StudentServiceBulkUpdatePage";

export const useStudentServiceListMenuItems = (props: {
  permission: Permission;
  loadList: () => void;
  setSelectedIds: (value: number[]) => void;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const menuItems: ListMenuItem[] = [];

  if (isAuthorized(props.permission, PermissionAction.Update))
    menuItems.push({
      label: "Update",
      action: (selectedIds: number[]) =>
        navigate(studentServiceBulkUpdatePageRoute.getPath(), {
          state: { selectedIds: selectedIds } as StudentServiceBulkUpdatePageState,
        }),
    });

  if (isAuthorized(props.permission, PermissionAction.BulkLock))
    menuItems.push({
      label: "Unlock",
      action: (selectedIds: number[]) => {
        if (window.confirm(BULK_UNLOCK_WARNING))
          ApiService.studentServices.postBulkUnlock(selectedIds).then(() => {
            props.setSelectedIds([]);
            dispatch(setAppToast(newToast("success")));
            props.loadList();
          });
      },
    });

  if (isAuthorized(props.permission, PermissionAction.BulkLock))
    menuItems.push({
      label: <Typography color="error">Lock</Typography>,
      action: (selectedIds: number[]) => {
        if (window.confirm(BULK_LOCK_WARNING))
          ApiService.studentServices.postBulkLock(selectedIds).then(() => {
            props.setSelectedIds([]);
            dispatch(setAppToast(newToast("success")));
            props.loadList();
          });
      },
    });

  if (isAuthorized(props.permission, PermissionAction.BulkDelete))
    menuItems.push({
      label: <Typography color="error">Delete</Typography>,
      action: (selectedIds: number[]) => {
        if (window.confirm(BULK_DELETE_WARNING))
          ApiService.studentServices.postBulkDelete(selectedIds).then(() => {
            props.setSelectedIds([]);
            dispatch(setAppToast(newToast("success")));
            props.loadList();
          });
      },
    });

  return menuItems;
};
